import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import './BikePackage.css';
import Nav from "../Nav";
import Footer from "../Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CarPackage = () => {
  const [carPackages, setCarPackages] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}AllPackages`);
        const result = await response.json();

        const allPackages = result?.data || [];
        const filteredCars = allPackages.filter(pkg =>
          pkg?.category?.name?.toLowerCase().includes("cars tour")
        );

        setCarPackages(filteredCars || []);
      } catch (error) {
        console.error("Error fetching car packages:", error);
      }
    };

    fetchPackages();
  }, []);
  return (
    <div className="container-fluid p-0">
      <Nav />

      <section className="w-100" style={{ backgroundColor: "#000" }}>
        <h1 className='d-none'>Best Car Packages</h1>
  <div className="dynamic-gallery">
    {carPackages.length === 0 ? (
      <p className="text-white text-center w-100">No Cars Tour Packages Found</p>
    ) : (
      carPackages.slice(0, 5).map((pkg, index) => {
        const isHovered = index === hoveredIndex;
        const isOtherHovered = hoveredIndex !== null && !isHovered;

        return (
          <div
            key={pkg?.id}
            className={`car-card ${isHovered ? 'hovered' : isOtherHovered ? 'dimmed' : ''}`}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={() => navigate(`/detail-car-package/${pkg?.name?.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`)}
          >
            <div className="car-card-inner">
              <img
                src={pkg?.image?.[0] || "/placeholder.svg?height=300&width=400"}
                alt={pkg?.name || `Tour ${index + 1}`}
              />
              <div className=" text-white">
                <div>
                <p className="fw-bold">0{index + 1}</p>
                <h2 className="mb-1" style={{fontSize: '19px'}}>{pkg?.name}</h2>
                <small className="car-location text-white">{pkg?.location}</small>
                </div>
              </div>
            </div>
          </div>
        );
      })
    )}
  </div>
</section>


      <div className="position-fixed bottom-0 end-0 m-4">
        <button
          className="btn btn-light rounded-circle shadow"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
            <path d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" />
          </svg>
        </button>
      </div>

      <Footer />
    </div>
  );
};

export default CarPackage;
